// extracted by mini-css-extract-plugin
export default {"localFilters":"LocalFilters_localFilters__p3QV4","filterItem":"LocalFilters_filterItem__U34EI"};